const STORAGE_KEY = "peak_signup_fbclid";

export interface StoredClick {
  fbclid: string;
  timestamp: number;
}

/** Meta click cookie: fb.1.{timestamp}.{fbclid} */
export function fbcFromClick(fbclid: string, timestamp: number): string {
  return `fb.1.${timestamp}.${fbclid}`;
}

export function rememberFbclid(search: string, now = Date.now()): void {
  if (typeof localStorage === "undefined") return;
  const fbclid = new URLSearchParams(search).get("fbclid");
  if (!fbclid) return;
  const stored: StoredClick = { fbclid, timestamp: now };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
}

export function readStoredClick(): StoredClick | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredClick>;
    if (typeof parsed.fbclid !== "string" || !parsed.fbclid) return null;
    if (typeof parsed.timestamp !== "number") return null;
    return { fbclid: parsed.fbclid, timestamp: parsed.timestamp };
  } catch {
    return null;
  }
}
